import { Box, Typography } from "@mui/material";
import { useScrollReveal } from "../../../helpers/ScrollReveal";
import { useEffect, useState } from "react";

export const HeroPortfolioSection = ({ image, text }) => {
  useScrollReveal([
    {
      selector: ".revealFromTopSectionHero",
      options: {
        duration: 1500,
        easing: "ease-out",
        origin: "top",
        reset: false,
      },
    },
  ]);
  const [initial, setInitial] = useState(true);

  useEffect(() => {
    setInitial(false);
  }, []);
  return (
    <Box
      component="section"
      sx={{
        backgroundColor: "#ffffff",
        width: "100%",
        height: "400px",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        position: "relative",
      }}
      className={initial ? "revealFromTopSectionHero" : ""}
    >
      <Box
        component="img"
        src={image}
        sx={{ width: "100%", height: "100%", objectFit: "cover" }}
      />
      {text && (
        <Typography
          sx={{
            position: "absolute",
            fontSize: { xs: "40px", md: "70px" },
            maxWidth: "80%",
            textAlign: "center",
            fontWeight: "500",
            color: "#fff",
            display: "flex",
            flexDirection: "column",
            textShadow: "0 1px 1px #000, 0 1px 2px #000, 0 2px 6px #000",
          }}
        >
          {text}
        </Typography>
      )}
    </Box>
  );
};
